import { Space, Table } from 'antd';
import { PermissionContext } from 'components/Global/AuthLayout';
import Ellipse from 'components/Global/Ellipse';
import { useContext } from 'react';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import styles from './index.module.scss';

const { Column } = Table;

type Props = {
	companyData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	setEditData: any;
	openDrawerHandler: any;
	setDrawerInfoHandler: any;
	showModal: any;
	isLoading: boolean;
};

const CompanyTable = (props: Props) => {
	const {
		companyData,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		openDrawerHandler,
		setDrawerInfoHandler,
		setEditData,
		showModal,
		isLoading,
	} = props;

	const permissions = useContext(PermissionContext);

	const editDataHandler = (selectedObj: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Company');
		setEditData(selectedObj);
	};

	// Delete user data handler
	const deleteDataHandler = (userObject: any) => {
		setEditData(userObject);
		showModal();
	};

	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={companyData}
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					// onShowSizeChange: pageSizeHandler,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
				<Column
					title="Company Name"
					dataIndex="name"
					key="name"
					width={'25%'}
					sorter={true}
					className="bg-white"
				/>
				<Column
					title="Company Address"
					// dataIndex="address"
					key="address"
					width={'25%'}
					className="bg-white"
					sorter={true}
					render={(_: any, data: any) => (
						<div>
							<Ellipse
								message={data.address}
								maxLength={25}
								isTooltip={true}
								tooltipMessage={data.address}
								key={data.email}
							/>
						</div>
					)}
				/>
				<Column
					title="Email"
					dataIndex="email"
					key="email"
					className="bg-white"
					sorter={true}
				/>
				<Column
					title="TPIN"
					dataIndex="tpin"
					key="tpin"
					width={'15%'}
					className="bg-white"
					sorter={true}
				/>
				{permissions.isSuperAdmin && (
					<Column
						title="Action"
						key="action"
						width={'10%'}
						className="bg-white"
						render={(_: any, data: any) => (
							<Space size={20}>
								<div
									className="cursor-pointer  flex align-center justify-center"
									onClick={() => editDataHandler(data)}
								>
									<EditActionSvg />
								</div>
								<div
									className="cursor-pointer flex align-center justify-center"
									onClick={() => deleteDataHandler(data)}
								>
									<DeleteActionSvg />
								</div>
							</Space>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default CompanyTable;
